const SidebarData = [
    {
        label: "Menu",
        isMainMenu: true,
    },
    {
        label: "Dashboard",
        icon: "mdi mdi-home-variant-outline",
        url: "/dashboard",
        issubMenubadge: true,
        // bgcolor: "bg-primary",
        // badgeValue: "3"
    },
    {
        label: "Contracts",
        isMainMenu: true,
    },
    {
        label: "Contracts",
        icon: "mdi mdi-file-document",
        url: "/contracts/contract",
        issubMenubadge: true,
    },
    {
        label: "NDAs",
        icon: "mdi mdi-shield-lock-outline",
        url: "/contracts/nda",
        issubMenubadge: true,
    },
    {
        label: "MOUs",
        icon: "mdi mdi-handshake-outline",
        url: "/contracts/mou",
        issubMenubadge: true,
    },
    {
        label: "Compliances",
        icon: "mdi mdi-check-decagram-outline",
        url: "/contracts/compliance",
        issubMenubadge: true,
    },
    {
        label: "Licenses",
        icon: "mdi mdi-certificate-outline",
        url: "/contracts/license",
        issubMenubadge: true,
    },
    {
        label: "Permits",
        icon: "mdi mdi-badge-account-outline",
        url: "/contracts/permit",
        issubMenubadge: true,
    },
    {
        label: "Others",
        icon: "mdi mdi-dots-horizontal-circle-outline",
        url: "/contracts/other",
        issubMenubadge: true,
    },
    {
        label: "Addendums",
        icon: "mdi mdi-file-plus-outline",
        url: "/addendums",
        issubMenubadge: true,
    },
    {
        label: "Map",
        isMainMenu: true,
    },
    {
        label: "Countries",
        icon: "mdi mdi-map",
        url: "/countries",
        issubMenubadge: true,
    },
    {
        label: "Profile",
        isMainMenu: true,
    },
    {
        label: "Users",
        icon: "mdi mdi-account-multiple-outline",
        isHasArrow: true,
        url: "/users",
    },
]
export default SidebarData;